import Vue from 'vue'

const components = [
  'CircleShape',
  'Picture',
  'VText',
  'VButton',
  'Group',
  'RectShape',
  'LineShape',
  'VTable',
  'VChart',
  'VMap',
  'ProjectName',
  'AreaAttendance',
  'VideoMonitor',
  'EnvironmentalMonitor',
  'TowerCrane',
  'DeviceVChartCom',
  'Lift',
  'VehicleRecord',
  'ElectricityVChartCom',
  'Picture',
  'Video'
]

components.forEach(key => {
  Vue.component(key, require(`./${key}/Component.vue`).default)
  Vue.component(key + 'Attr', require(`./${key}/Attr.vue`).default)
})

const svgs = [
  'SVGStar',
  'SVGTriangle'
]

svgs.forEach(key => {
  Vue.component(key, require(`./svgs/${key}/Component.vue`).default)
  Vue.component(key + 'Attr', require(`./svgs/${key}/Attr.vue`).default)
})
